import { createSlice } from "@reduxjs/toolkit";
import uuidv4 from "uuid/v4";

const initialState = {
    "id" : uuidv4(),
    "theme": {}
}
const customThemeListner = createSlice({
    name:'themeListner',
    initialState,
    reducers:{
        customTheme: (_state,payload)=>{
               return {
                "id" : uuidv4(),
                "theme": payload.payload
               }
        }
    }
});

export default customThemeListner.reducer
export const customTheme = customThemeListner.actions.customTheme